<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">
              Perguntas de Perfil
              <TotalRegisters :total="profilesTableData.total" totalText="perguntas cadastradas" />
              <Search @doSearch="doSearch" />
            </h4>
            <div class="col-lg-6 d-flex align-items-end justify-content-end mb-3 flex-wrap">
              <div class="d-flex align-items-center">
                <button class="btn btn-info btn-sm" id="AddTurboPergQuesPesq" @click="openCreateModalTurbo()">Adicionar Pergunta + Questão + Pesquisa</button>
              </div>
              <div class="d-flex align-items-center">
                <button class="btn btn-info btn-sm" id="AddPesq" @click="openCreateModal()">Adicionar Pergunta</button>
              </div>
            </div>
          </div>

          <Table :tableData="profilesTableData" :data="profiles" :columns="['id', 'question', 'actions']" :actions="['edit', 'delete']" @pagechanged="onPageChange" @openEditModal="openEditModal" @openDeleteModal="openDeleteModal"> </Table>
          <ListLoader v-if="profilesTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!profilesTableData.loading && profilesTableData.error"></Error>
          <Empty v-if="!profilesTableData.loading && !profilesTableData.error && profiles.length === 0"></Empty>
        </card>
      </div>
    </div>

    <!-- Edit -->
    <Modal v-model="visibilityStates.edit" action="Salvar" title="Editar Pergunta de Perfil" @closeModal="visibilityStates.edit = false" @confirmAction="update(profile.id)">
      <template v-slot:body>
        <div class="row mt-2">
          <div class="col-12">
            <div class="form-group">
              <label>Identificador</label>
              <input class="form-control" type="text" placeholder="Slug para identificar a pergunta" v-model="slug" />
            </div>

            <div class="form-group">
              <label>Pergunta</label>
              <input class="form-control" type="text" placeholder="Pergunta sem título" v-model="question" />
            </div>

            <div class="form-group">
              <label>Imagem <small>(obrigatório)</small></label>
              <FormulateInput type="image" label="" help="" validation="mime:image/jpeg,image/png,image/gif" v-model="imageFile" @change="changeImage()" />
            </div>

            <div class="form-group">
              <label>Tipo do campo</label>
              <select v-model="typeField" id="selectEdit" class="form-control">
                <option value="date">Data</option>
                <!-- <option value="dropdown">Lista</option> Necessário adicionar no front--> 
                <option value="mask">Máscara</option>
                <option value="money">Monetário</option>
                <option value="multiMoney">Múltiplo Monetário</option>
                <option value="checkbox">Múltipla Seleção</option>
                <option value="multiSelect">Múltipla Seleção com Input</option>
                <option value="number">Numérico</option>
                <option value="smallText">Resposta Curta</option>
                <option value="radio">Resposta Única</option>
                <option value="simpleSelect">Resposta Única com Input</option>
              </select>
            </div>

            <div class="form-group" v-if="typeField === 'radio' || typeField === 'simpleSelect'">
              <label class="mb-0">Opções</label>
            </div>

            <div class="mt-2" v-if="typeField === 'radio' || typeField === 'simpleSelect'">
              <div v-for="opt in options" :key="opt.id" class="form-group d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center">
                  <input type="radio" :checked="false" disabled />
                  <input type="text" class="form-control ml-2" v-model="opt.label" />
                </div>
                <div>
                  <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">&#x2715;</button>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-info btn-sm" @click="addOption()">Adicionar opção</button>
              </div>
            </div>

            <div class="mt-2" v-if="typeField === 'mask'">
              <div class="form-group">
                <label>Insira a sua mascara</label>
                <input class="form-control" type="text" placeholder="Ex: ###.###.###-##" v-model="mask" />
              </div>
            </div>

            <div class="mt-2" v-if="typeField === 'checkbox' || typeField === 'multiSelect' || typeField === 'multiMoney'">
              <div v-for="opt in options" :key="opt.id" class="form-group d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center">
                  <input v-if="typeField != 'multiMoney'" type="checkbox" :checked="false" disabled />
                  <input type="text" class="form-control ml-2" v-model="opt.label" />
                </div>
                <div>
                  <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">&#x2715;</button>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-info btn-sm" @click="addOption()">Adicionar opção</button>
              </div>
            </div>

            <div class="mt-2" v-if="typeField === 'dropdown'">
              <div v-for="opt in options" :key="opt.id" class="form-group d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center">
                  <label class="mb-0">{{ opt.id }}.</label>
                  <input type="text" class="form-control ml-2" v-model="opt.label" />
                </div>
                <div v-if="options.length > 1">
                  <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">&#x2715;</button>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-info btn-sm" @click="addOption()">Adicionar opção</button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>
    <!-- Create turbo profileQuestion -->
    <Modal v-model="visibilityStates.createTurbo" action="Salvar Sequência" title="Adicionar nova Pergunta de Perfil - Cascata" :scroll="true" @closeModal="visibilityStates.createTurbo = false" @confirmAction="createProfileQuestionTurbo(slug, question, typeField, options, mask)">
      <template v-slot:body>
        <div class="row mt-2">
          <div class="col-12">
            <div class="form-group">
              <label>Identificador <small>(obrigatório)</small></label>
              <input class="form-control" type="text" placeholder="Slug para identificar a pergunta" v-model="slug" />
            </div>

            <div class="form-group">
              <label>Pergunta <small>(obrigatório)</small></label>
              <input class="form-control" type="text" placeholder="Insira a pergunta" v-model="question" />
            </div>

            <div class="form-group">
              <label>Imagem <small>(obrigatório)</small></label>
              <FormulateInput type="image" label="" help="" validation="mime:image/jpeg,image/png,image/gif" v-model="imageFile" />
            </div>

            <div class="form-group">
              <label>Tipo do campo</label>
              <select v-model="typeField" id="selectCreateTurbo" class="form-control">
                <option value="date">Data</option>
                <!-- <option value="dropdown">Lista</option> -->
                <option value="mask">Máscara</option>
                <option value="money">Monetário</option>
                <option value="multiMoney">Múltiplo Monetário</option>
                <option value="checkbox">Múltipla Seleção</option>
                <option value="multiSelect">Múltipla Seleção com Input</option>
                <option value="number">Numérico</option>
                <option value="smallText">Resposta Curta</option>
                <option value="radio">Resposta Única</option>
                <option value="simpleSelect">Resposta Única com Input</option>
              </select>
            </div>
            
            <div class="form-group" v-if="typeField === 'radio' || typeField === 'simpleSelect'">
              <label class="mb-0">Opções</label>
            </div>

            <div class="mt-2" v-if="typeField === 'radio' || typeField === 'simpleSelect'">
              <div v-for="(opt, i) in options" :key="i" class="form-group d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center">
                  <input type="radio" :checked="false" disabled />
                  <input type="text" class="form-control ml-2" v-model="opt.label" />
                </div>
                <div>
                  <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">&#x2715;</button>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-info btn-sm" @click="addOption()">Adicionar opção</button>
              </div>
            </div>

            <div class="mt-2" v-if="typeField === 'mask'">
              <div class="form-group">
                <label>Insira a sua mascara</label>
                <input class="form-control" type="text" placeholder="Ex: ###.###.###-##" v-model="mask" />
              </div>
            </div>

            <div class="mt-2" v-if="typeField === 'checkbox' || typeField === 'multiSelect' || typeField === 'multiMoney'">
              <div v-for="(opt, i) in options" :key="i" class="form-group d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center">
                  <input v-if="typeField != 'multiMoney'" type="checkbox" :checked="false" disabled />
                  <input type="text" class="form-control ml-2" v-model="opt.label" />
                </div>
                <div>
                  <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">&#x2715;</button>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-info btn-sm" id="addOption" @click="addOption()">Adicionar opção</button>
              </div>
            </div>

            <div class="mt-2" v-if="typeField === 'dropdown'">
              <div v-for="(opt, i) in options" :key="i" class="form-group d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center">
                  <label class="mb-0">{{ opt.id }}.</label>
                  <input type="text" class="form-control ml-2" v-model="opt.label" />
                </div>
                <div v-if="options.length > 1">
                  <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">&#x2715;</button>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-info btn-sm" @click="addOption()">Adicionar opção</button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <!-- Create -->
    <Modal v-model="visibilityStates.create" action="Salvar" title="Adicionar nova Pergunta de Perfil" @closeModal="visibilityStates.create = false" :scroll="true" @confirmAction="createProfileQuestion(slug, question, typeField, options, mask)">
      <template v-slot:body>
        <div class="row mt-2">
          <div class="col-12">
            <div class="form-group">
              <label>Identificador <small>(obrigatório)</small></label>
              <input class="form-control" type="text" placeholder="Slug para identificar a pergunta" v-model="slug" />
            </div>

            <div class="form-group">
              <label>Pergunta <small>(obrigatório)</small></label>
              <input class="form-control" type="text" placeholder="Insira a pergunta" v-model="question" />
            </div>

            <div class="form-group">
              <label>Imagem <small>(obrigatório)</small></label>
              <FormulateInput type="image" label="" help="" validation="mime:image/jpeg,image/png,image/gif" v-model="imageFile" />
            </div>

            <div class="form-group">
              <label>Tipo do campo</label>
              <select v-model="typeField" id="selectCreate" class="form-control">
                <option value="date">Data</option>
                <!-- <option value="dropdown">Lista</option> -->
                <option value="mask">Máscara</option>
                <option value="money">Monetário</option>
                <option value="multiMoney">Múltiplo Monetário</option>
                <option value="checkbox">Múltipla Seleção</option>
                <option value="multiSelect">Múltipla Seleção com Input</option>
                <option value="number">Numérico</option>
                <option value="smallText">Resposta Curta</option>
                <option value="radio">Resposta Única</option>
                <option value="simpleSelect">Resposta Única com Input</option>
              </select>
            </div>

            <div class="form-group" v-if="typeField === 'radio'|| typeField === 'simpleSelect'">
              <label class="mb-0">Opções</label>
            </div>

            <div class="mt-2" v-if="typeField === 'radio' || typeField === 'simpleSelect'">
              <div v-for="(opt, i) in options" :key="i" class="form-group d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center">
                  <input type="radio" :checked="false" disabled />
                  <input type="text" class="form-control ml-2" v-model="opt.label" />
                </div>
                <div>
                  <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">&#x2715;</button>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-info btn-sm" @click="addOption()">Adicionar opção</button>
              </div>
            </div>

            <div class="mt-2" v-if="typeField === 'mask'">
              <div class="form-group">
                <label>Insira a sua mascara</label>
                <input class="form-control" type="text" placeholder="Ex: ###.###.###-##" v-model="mask" />
              </div>
            </div>

            <div class="mt-2" v-if="typeField === 'checkbox' || typeField === 'multiSelect' || typeField === 'multiSelect'">
              <div v-for="(opt, i) in options" :key="i" class="form-group d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center">
                  <input v-if="typeField != 'multiMoney'" type="checkbox" :checked="false" disabled />
                  <input type="text" class="form-control ml-2" v-model="opt.label" />
                </div>
                <div>
                  <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">&#x2715;</button>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-info btn-sm" id="addOption" @click="addOption()">Adicionar opção</button>
              </div>
            </div>

            <div class="mt-2" v-if="typeField === 'dropdown'">
              <div v-for="(opt, i) in options" :key="i" class="form-group d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center">
                  <label class="mb-0">{{ opt.id }}.</label>
                  <input type="text" class="form-control ml-2" v-model="opt.label" />
                </div>
                <div v-if="options.length > 1">
                  <button class="btn btn-sm btn-icon mr-1 btn-success" @click="removeOption(opt.id)">&#x2715;</button>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-info btn-sm" @click="addOption()">Adicionar opção</button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <Modal v-model="visibilityStates.delete" successMessage="Pergunta removida com sucesso!" action="Remover" :name="profile.name" title="Remover Pergunta" @closeModal="visibilityStates.delete = false" @confirmAction="remove(profile.id)">
      <template v-slot:body>
        <div class="form-group">
          <label>Pergunta</label>
          <input type="text" hidden class="form-control" v-model="profile.id" />
          <input type="text" class="form-control" v-model="profile.question" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import api from '@/api.js';
import Vue from 'vue';
import VueFormulate from '@braid/vue-formulate';
Vue.use(VueFormulate);
import Table from '@/components/Common/Table';
import Search from '@/components/Common/Search';
import TotalRegisters from '@/components/Common/TotalRegisters';
import Modal from '@/components/Modal/Modal';
export default {
  components: {
    Modal,
    TotalRegisters,
    Search,
    Table,
  },
  data() {
    return {
      visibilityStates: {
        createTurbo: false,
        create: false,
        edit: false,
        delete: false,
      },
      slug: '',
      typeField: 'smallText',
      question: '',
      options: [],
      mask: '',
      imageFile: null,
      newImage: false,
    };
  },
  computed: {
    profiles() {
      return this.$store.getters['profiles/getProfiles'];
    },
    profilesTableData() {
      return this.$store.getters['profiles/getProfilesTableData'];
    },
    profile() {
      return this.$store.getters['profiles/getProfile'];
    },
    isValidFields() {
      if (this.slug !== '' && this.question !== '' && this.typeField !== '' && this.imageFile) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    changeImage() {
      this.newImage = true;
    },
    submitFile: async function (profileId) {
      let formData = new FormData();
      formData.append('image', this.imageFile.fileList[0]);

      const res = await api.patch(`profiles/questions/images/${profileId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    doSearch: async function (search) {
      let payload = {};
      payload.search = search;
      payload.page = 1;
      payload.limit = 10;
      this.$store.dispatch('profiles/searchProfile', payload);
    },
    onPageChange(page) {
      this.$store.dispatch('profiles/setPage', page);
    },
    addOption() {
      if (this.options.length === 0) {
        this.options.push({ id: 1, label: 'Opção 1' });
      } else {
        const maxId = Math.max(...this.options.map(option => option.id));
        this.options.push({ id: maxId + 1, label: `Opção ${maxId + 1}` });
      }
    },
    removeOption(id) {
      this.options = this.options.filter((s) => s.id !== id);
    },
    async resetFields() {
      this.slug = '';
      this.typeField = 'smallText';
      this.question = '';
      this.options = [];
      this.mask = '';
      this.imageFile = null;
    },

    async openCreateModal() {
      this.resetFields();
      this.visibilityStates.create = true;
    },

    async openCreateModalTurbo() {
      this.resetFields();
      this.visibilityStates.createTurbo = true;
    },
    async openEditModal(id) {
      await this.$store.dispatch('profiles/getProfileById', id);
      this.slug = this.profile.slug;
      this.question = this.profile.question;
      this.typeField = this.profile.typeField;
      this.options = this.profile.options;
      this.mask = this.profile.mask;
      this.imageFile = [];
      this.imageFile.push({ name: this.profile.imageName, url: `${process.env.VUE_APP_BUCKET_URL}/${this.profile.imageName}` });
      this.newImage = false;
      this.visibilityStates.edit = true;
    },
    async openDeleteModal(id) {
      await this.$store.dispatch('profiles/getProfileById', id);
      this.visibilityStates.delete = true;
    },
    update: async function (id) {
      let payload = {};
      payload.id = id;
      payload.params = {
        question: this.question,
        slug: this.slug,
        typeField: this.typeField,
        options: this.options,
        mask: this.mask,
      };

      await this.$store.dispatch('profiles/update', payload);
      if (this.newImage) {
        this.submitFile(payload.id);
      }
      this.visibilityStates.edit = false;
    },
    remove: async function (id) {
      await this.$store.dispatch('profiles/remove', id);
      this.visibilityStates.delete = false;
      this.$store.dispatch('profiles/resetPagination');
    },
    async createProfileQuestion(slug, question, typeField, options, mask) {
      if (this.isValidFields) {
        let payload = {};
        payload.question = question;
        payload.typeField = typeField;
        payload.slug = slug;
        payload.options = options;
        payload.mask = mask;
        const profileId = await this.$store.dispatch('profiles/create', payload);
        this.submitFile(profileId);
        this.visibilityStates.create = false;
      } else {
        this.$notify({
          icon: 'tim-icons icon-bell-55',
          type: 'danger',
          timeout: 3000,
          message: 'Preencha os campos obrigatórios',
        });
      }
    },
    async createProfileQuestionTurbo(slug, question, typeField, options, mask) {
      if (this.isValidFields) {
        let questionId;
        const payload = { question, typeField, slug, options, mask };
        let profileId = await this.$store.dispatch('profiles/create', payload);
        this.submitFile(profileId);

        try {
          const payloadQuestion = { brandsId: null, profileId, type: 'profile' };
          questionId = await this.$store.dispatch('questions/create', payloadQuestion);
        } catch (error) {
          this.showNotifications('danger', 'Erro ao criar a questão');
        }

        try {
          const { data } = await api.get(`/surveys`);
          const payloadCampaign = { order: data.length, questionId };
          await api.post(`surveys`, payloadCampaign);
        } catch (error) {
          this.showNotifications('danger', 'Erro ao criar a pesquisa');
        }
        this.showNotifications('success', 'Pesquisa criada com sucesso!');

        this.resetFields();
        this.visibilityStates.createTurbo = false;
      } else {
        this.showNotifications('danger', 'Preencha os campos obrigatórios');
      }
    },
    showNotifications(type, message) {
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: type,
        timeout: 3000,
        message: message,
      });
    },
  },
  mounted() {
    this.$store.dispatch('profiles/getProfiles');
  },
};
</script>
<style scoped></style>
